import React from "react";

import rewards0 from "@pages/learn/assets/composition/pic1.png";
import rewards1 from "@pages/learn/assets/composition/pic2.png";
import rewards2 from "@pages/learn/assets/composition/pic3.png";
import rewards3 from "@pages/learn/assets/composition/pic4.png";
import rewards4 from "@pages/learn/assets/composition/pic5.png";
import rewards5 from "@pages/learn/assets/composition/pic6.png";

const rewardsheight = "225px";
const text = "incomplete puzzle";

export const COMPOSITION_REWARDS: React.ReactNode[] = [
  <img
    className="image"
    src={rewards0}
    height={rewardsheight}
    alt="empty puzzle"
  ></img>,
  <img
    className="image"
    src={rewards1}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards2}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards3}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards4}
    height={rewardsheight}
    alt={text}
  ></img>,
  <img
    className="image"
    src={rewards5}
    height={rewardsheight}
    alt={text}
  ></img>,
];
